'use client';

import React from 'react';
import Script from 'next/script';
import {
  LOGIN_CODE_CAPTCHA_CLICK_ID,
  LOGIN_CODE_CAPTCHA_ID,
} from '@/constants/component-id';

const Captcha = React.forwardRef(
  (
    props: { onSuccess: (captchaVerifyParam: any) => void; sceneId?: string },
    ref,
  ) => {
    const { onSuccess, sceneId = '18k4fzr2' } = props;

    let captcha: any;
    const getInstance = (instance: any) => {
      captcha = instance;
    };

    const initCaptcha = React.useCallback(() => {
      (window as any).initAliyunCaptcha?.({
        prefix: '1cdnxt',
        region: 'cn',
        SceneId: sceneId,
        mode: 'popup',
        element: `#${LOGIN_CODE_CAPTCHA_ID}`,
        button: `#${LOGIN_CODE_CAPTCHA_CLICK_ID}`,
        success: onSuccess,
        getInstance: getInstance,
        language: 'cn',
      });
    }, [onSuccess]);

    React.useImperativeHandle(ref, () => ({ initCaptcha }));

    return (
      <>
        <Script
          src="https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js"
          onLoad={initCaptcha}
          strategy="afterInteractive"
        />
        <div className="hidden" id={LOGIN_CODE_CAPTCHA_ID} />
      </>
    );
  },
);

export default Captcha;
